import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import useLenis from "@/hooks/useLenis";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import Home from "@/pages/Home";
import VideosPage from "@/pages/VideosPage";
import ArticlesPage from "@/pages/ArticlesPage";
import ArticlePage from "@/pages/ArticlePage";
import InspirationPage from "@/pages/InspirationPage";
import GalleryPage from "@/pages/GalleryPage";
import SharePage from "@/pages/SharePage";
import StoryPage from "@/pages/StoryPage";
import ShopPage from "@/pages/ShopPage";
import TellTheirStoryPage from "@/pages/TellTheirStoryPage";
import HaroldPage from "@/pages/HaroldPage";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import api from "@/lib/api";

function PublicSite() {
  useLenis();
  const [settings, setSettings] = useState(null);
  useEffect(() => { api.get("/settings").then((r) => setSettings(r.data)).catch(() => {}); }, []);
  return (
    <div className="bg-imi-bg text-imi-text">
      <Header />
      <main><Home settings={settings} /></main>
      <Footer settings={settings} />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <div className="noise-overlay" />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PublicSite />} />
            <Route path="/videos" element={<VideosPage />} />
            <Route path="/articles" element={<ArticlesPage />} />
            <Route path="/articles/:id" element={<ArticlePage />} />
            <Route path="/inspiration" element={<InspirationPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/share" element={<SharePage />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/tell-their-story" element={<TellTheirStoryPage />} />
            <Route path="/harold" element={<HaroldPage />} />
            <Route path="/stories/:id" element={<StoryPage />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" toastOptions={{
          style: { background: "#121212", border: "1px solid #27272a", color: "#f5f2ea" },
        }} />
      </AuthProvider>
    </div>
  );
}

export default App;
